<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <div>
            {{ title }}
          </div>
        </div>
        <div class="modal_body">
          <div class="body">
            <div class="status">
              <div class="old_status_label_value">
                <div class="old_status_label">
                  {{ oldStatusLabelValue1 }}
                </div>
                <div class="status_color_1"></div>
                <div class="detail_status_label">
                  {{ statusLabelValue1 }}
                </div>
              </div>
              <div class="new_status_label_value">
                <div class="label">
                  {{ newStatusLabelValue1 }}
                  <div class="require_items_label">
                    {{ requiredItemLabel }}
                  </div>
                </div>
                <input
                  type="text"
                  id="new_status_label_value"
                  v-model="inputNewStatusLabelValue1"
                />
              </div>
            </div>
            <div>
              <div class="old_status_label_value">
                <div class="old_status_label">
                  {{ oldStatusLabelValue2 }}
                </div>
                <div class="status_color_2"></div>
                <div class="detail_status_label">
                  {{ statusLabelValue2 }}
                </div>
              </div>
              <div class="new_status_label_value">
                <div class="label">
                  {{ newStatusLabelValue2 }}
                  <div class="require_items_label">
                    {{ requiredItemLabel }}
                  </div>
                </div>
                <input
                  type="text"
                  id="new_status_label_value"
                  v-model="inputNewStatusLabelValue2"
                />
              </div>
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="changeButton"
              class="finish_button"
              @click="showConfirmModal = true"
            />
          </div>
          <div class="modal_window" v-if="showConfirmModal">
            <confirmModalWindow
              :question="changeWord"
              @close="stayClose"
              @ok="changeStatusLabel"
            >
            </confirmModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confirmModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from './loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'ステータス文言変更',
      oldStatusLabelValue1: '現在のステータス１ 文言 :',
      newStatusLabelValue1: '新しいステータス１ 文言 :',
      oldStatusLabelValue2: '現在のステータス２ 文言 :',
      newStatusLabelValue2: '新しいステータス２ 文言 :',
      changeWord: 'ステータス文言を変更しますか？',
      failureWord: '',
      cancelButton: 'キャンセル',
      changeButton: '変更',
      showConfirmModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    confirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    statusLabelValue1() {
      return this.$store.state.masters.statusData.statusName1
    },
    statusLabelValue2() {
      return this.$store.state.masters.statusData.statusName2
    },
    statusIDValue1() {
      return this.$store.state.masters.statusData.statusId1
    },
    statusIDValue2() {
      return this.$store.state.masters.statusData.statusId2
    }
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showConfirmModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showloadingModal = false
    },
    async changeStatusLabel(e) {
      // ステータス文言設定変更のコードを記述
      let eventNumber = this.$store.state.error.errorCode.errorCode_430010
      this.showloadingModal = true
      this.showConfirmModal = false
      if (!this.inputNewStatusLabelValue1) {
        this.failureWord =
          this.errorMsg.MSGCRC0187.name +
          this.errorMsg.MSGCRC0187.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else if (!this.inputNewStatusLabelValue2) {
        this.failureWord =
          this.errorMsg.MSGCRC0189.name +
          this.errorMsg.MSGCRC0189.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else {
        try {
          await this.$store.dispatch('masters/updateStatusLabelValue', {
            statusId1: this.statusIDValue1,
            statusName1: this.inputNewStatusLabelValue1,
            statusId2: this.statusIDValue2,
            statusName2: this.inputNewStatusLabelValue2
          })
          this.completeWord = 'ステータス文言を変更しました。'
          this.showCompleteModal = true
        } catch (error) {
          let eventType = 3
          let reason = 'MSGCRC0188'
          if (
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.message
          ) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0188') {
              this.failureWord =
                this.errorMsg.MSGCRC0188.name +
                this.errorMsg.MSGCRC0188.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0190') {
              this.failureWord =
                this.errorMsg.MSGCRC0190.name +
                this.errorMsg.MSGCRC0190.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0191.name +
                this.errorMsg.MSGCRC0191.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.failureWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFailureModal = true
        }
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  width: 435px;
  height: 520px;
}
.modal_header {
  display: table;
  width: 100%;
}
.modal_header div {
  padding-left: 14px;
  display: table-cell;
  vertical-align: middle;
}
.modal_body {
  height: 276px;
}
.body {
  height: 233px;
  padding-top: 40px;
}
.require_items_label {
  margin-bottom: 3px;
}
.old_status_label {
  width: 55%;
  float: left;
}
.status_color_1 {
  width: 20%;
  height: 19px;
  float: left;
  background-color: rgb(233, 85, 4);
}
.status_color_2 {
  width: 20%;
  height: 19px;
  float: left;
  background-color: rgb(174, 174, 174);
}
.detail_status_label {
  font-size: 14px;
  padding-bottom: 10px;
  clear: left;
}
.status {
  border-bottom: 1px solid #a6e3e0;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/changeStatusLabelModalWindow.vue